var React = require('react');

function IcEsc (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 13.0606L16.6161 17.6768C16.8114 17.872 17.1262 17.8738 17.3288 17.6712L17.6712 17.3287C17.8696 17.1304 17.8748 16.8141 17.6768 16.6161L13.0607 12L17.6768 7.38383C17.872 7.18858 17.8738 6.87379 17.6712 6.67121L17.3288 6.32873C17.1304 6.13041 16.8142 6.12514 16.6161 6.32317L12 10.9393L7.38386 6.32317C7.18861 6.12792 6.87383 6.12614 6.67124 6.32873L6.32876 6.67121C6.13044 6.86953 6.12517 7.1858 6.3232 7.38383L10.9393 12L6.3232 16.6161C6.12795 16.8114 6.12617 17.1261 6.32876 17.3287L6.67124 17.6712C6.86956 17.8695 7.18583 17.8748 7.38386 17.6768L12 13.0606Z","fill":"#17181A"}));
}

IcEsc.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IcEsc;

IcEsc.default = IcEsc;
